import { TooltipView } from "../../../components/Tooltip";
import { useApp } from "../../../services/app-context";

export function AIOverview({ report }) {
  const { tenantProfile } = useApp();
  const info_badges = tenantProfile?.info_badges || {};
  return (
    <div className="bg-white shadow-[0px_4px_24px_0px_rgba(203,90,90,0.05)] p-5 rounded-[14px]">
      <div className="flex items-center gap-2">
        <span className="font-semibold text-sm text-text-primary">Action Items</span>
        {!!info_badges?.action_items && (<TooltipView
            content={info_badges?.action_items}
            id="action-items"
            iconClassName="!w-5 !h-5"
          />
        )}
      </div>
      <div className="h-auto overflow-auto flex flex-col gap-5 [&_li]:text-xs [&_li]:leading-[20px] [&_li+_li]:mt-2">
        {typeof report?.report?.summary === 'string' && <div
          className="font-normal text-xs text-text-primary capitalize [&_:is(ol,ul)]:font-normal [&_:is(ol,ul)]:normal-case [&_:is(ol,ul)]:text-text-primary/60 [&_:is(ol,ul)]:!mx-0 [&_:is(ol,ul)]:!my-1 [&_:is(ol,ul)]:!px-4 [&_:is(ol,ul)]:!py-0 [&_:is(ol,ul)]:text-[15px] [&_:is(ol,ul)]:!list-decimal [&_:is(ol,ul)]:p-[revert] [&_:is(ol,ul)]:m-[revert]"
          dangerouslySetInnerHTML={{
            __html: report?.report?.summary || "",
          }}
        />}
        {
          typeof report?.report?.summary === 'object' && Array.isArray(report?.report?.summary) && report?.report?.summary?.length > 0 && (
            <ol className="list-decimal pl-5 text-xs text-text-primary">
              {report?.report?.summary?.map((item: any, index: number) => (
                <li key={index} className="pl-1">
                  <span className="font-bold">{item.heading}:</span> <span className="font-normal">{item.text || ""}</span>
                </li>
              ))}
            </ol>
          )
        }
      </div>
    </div>
  );
}
